// extracted by mini-css-extract-plugin
module.exports = {"result":"styles_result__APqh3","text":"styles_text__14xtC","rightAnswers":"styles_rightAnswers__2RjQz","buttonGroup":"styles_buttonGroup__3sZ7Q"};